// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Context = require("../provider/Context.bs.js");
var Organism_HeaderLabels = require("../design-system/organism/header/Organism_HeaderLabels.bs.js");

function toDsNavigation(menuItems, param) {
  var match = Context.Config.getState(undefined);
  var baseUrl = match.baseUrl;
  var match$1 = Context.I18n.getState(undefined);
  var data = React.useMemo((function () {
          return Organism_HeaderLabels.$$default(baseUrl);
        }), [baseUrl]);
  var dataByLocale;
  switch (match$1.locale) {
    case /* Fr */0 :
        dataByLocale = data.fr;
        break;
    case /* De */1 :
        dataByLocale = data.de;
        break;
    case /* Pl */2 :
        dataByLocale = data.pl;
        break;
    case /* It */3 :
        dataByLocale = data.it;
        break;
    case /* En */4 :
        dataByLocale = data.en;
        break;
    case /* Es */5 :
        dataByLocale = data.es;
        break;
    
  }
  if (menuItems === undefined) {
    return dataByLocale;
  }
  var init = dataByLocale.MenuNavigation;
  return {
          Club: dataByLocale.Club,
          Languages: dataByLocale.Languages,
          DesktopNavigation: dataByLocale.DesktopNavigation,
          MenuNavigation: {
            mobileLinks: init.mobileLinks,
            categories: menuItems.main,
            otherLinks: menuItems.secondary
          },
          SearchNavigation: dataByLocale.SearchNavigation,
          LogoNavigation: dataByLocale.LogoNavigation,
          RedirectionAnchor: dataByLocale.RedirectionAnchor,
          Concert: dataByLocale.Concert,
          InstallApp: dataByLocale.InstallApp,
          Settings: dataByLocale.Settings
        };
}

exports.toDsNavigation = toDsNavigation;
/* react Not a pure module */
